export default {
    data: {
        type: Object,
        default() {
            return {}
        }
    },

    type: {
        type: Number,
        default: 0
    }
}
